import { useEffect, useState } from 'react'

import { getWhySiso } from '../Contentful'

export default function useWhySiso() {
  const promise = getWhySiso()
  // console.log("test 3");
  const [whySiso, setWhySiso] = useState(null)
  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    promise.then(result => {
      setWhySiso(result)
      setLoading(false)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return [whySiso, isLoading]
}